export default {"src":"/_next/static/media/icon-2.f4d61b09.svg","height":28,"width":28,"blurWidth":0,"blurHeight":0};